import { render, staticRenderFns } from "./ViewPerformanceManagement.vue?vue&type=template&id=c2608cd0&"
import script from "./ViewPerformanceManagement.vue?vue&type=script&lang=js&"
export * from "./ViewPerformanceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports